import ButtonPrimary from 'components/ButtonPrimary'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { SuccessEmailIcon } from 'components/Icon/icons/success-email/index.js'

const messages = defineMessages({
  checkYourEmailSentLink: {
    id: 'SigninSignupFlowForgotPasswordSuccess.checkYourEmailSentLink',
    defaultMessage: 'We’ve sent you a link to reset your password'
  },
  done: {
    id: 'SigninSignupFlowForgotPasswordSuccess.done',
    defaultMessage: 'Done'
  },
  checkYourEmail: {
    id: 'SigninSignupFlowForgotPasswordSuccess.checkYourEmail',
    defaultMessage: 'Check your email'
  }
})

export default function SigninSignupFlowForgotPasswordSuccess (props) {
  const intl = useIntl()
  const {
    emailOrName,
    forgotPasswordDoneButtonHide,
    onClose
  } = props

  return (
    <View
      ac
    >
      <Text
        fw='700'
        fs='1.125em'
        c='#151D21'
        mt='24px'
        style={{
          textTransform: 'uppercase',
          lineHeight: '22px',
          transform: 'scaleX(0.8) scaleY(1)',
          transformOrigin: '50% 0',
          textAlign: 'center',
          width: '100%'
        }}
      >
        {formatMessageIntlUtil(intl, messages.checkYourEmail)}
      </Text>
      <Text
        fw='700'
        fs='1.125em'
        c='#151D21'
        mb='40px'
        style={{
          textTransform: 'uppercase',
          lineHeight: '22px',
          transform: 'scaleX(0.8) scaleY(1)',
          transformOrigin: '50% 0',
          textAlign: 'center',
          width: '100%',
          textDecoration: 'underline'
        }}
      >
        {emailOrName}
      </Text>
      <SuccessEmailIcon />
      <Text
        fw='700'
        fs='1.125em'
        c='#151D21'
        mt='40px'
        mb='20px'
        style={{
          textTransform: 'uppercase',
          lineHeight: '22px',
          transform: 'scaleX(0.8) scaleY(1)',
          transformOrigin: '50% 0',
          textAlign: 'center',
          width: '100%'
        }}
      >
        {formatMessageIntlUtil(intl, messages.checkYourEmailSentLink)}
      </Text>
      {!forgotPasswordDoneButtonHide && (
        <View w='100%'>
          <ButtonPrimary
            isFullWidth
            onClick={onClose}
          >
            <Text
              c='#ffffff'
              fs='0.9375em'
            >
              {formatMessageIntlUtil(intl, messages.done)}
            </Text>
          </ButtonPrimary>
        </View>
      )}
    </View>
  )
}
